// extracted by mini-css-extract-plugin
module.exports = {"formClass":"tQ","setupPinButton":"tR","submitButton":"tS","cancelButton":"tT","enterPinHelpText":"tU"};